// Registry of "is there unsaved work on screen?" getters, read by the silent
// app-update gate. Guards register while mounted; a getter that throws counts
// as dirty (fail closed — never reload on a question we could not answer).

const getters = new Set();

export function registerUnsavedWork(getter) {
  if (typeof getter !== 'function') return () => {};
  getters.add(getter);
  return () => { getters.delete(getter); };
}

export function hasUnsavedWork() {
  for (const getter of getters) {
    try {
      if (getter()) return true;
    } catch (_) {
      return true;
    }
  }
  return false;
}

export function __resetUnsavedWorkRegistryForTests() {
  getters.clear();
}
